import { render, staticRenderFns } from "./product5.vue?vue&type=template&id=9f5f9158&scoped=true"
import script from "./product5.vue?vue&type=script&lang=js"
export * from "./product5.vue?vue&type=script&lang=js"
import style0 from "./product5.vue?vue&type=style&index=0&id=9f5f9158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5f9158",
  null
  
)

export default component.exports